'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import { BASE_SPACING_X } from 'HubStyleTokens/sizes';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import UIAccordionItem from '../accordion/UIAccordionItem';
import UICardSection from '../card/UICardSection';
import AbstractTextElement from '../elements/AbstractTextElement';
import UIFlex from '../layout/UIFlex';
import { allSizes, toShorthandSize } from '../utils/propTypes/tshirtSize';
import omit from '../utils/underscore/omit';
var headingForSize = {
  xs: 'span',
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};
var Toolbar = styled.div.withConfig({
  displayName: "UICardHeader__Toolbar",
  componentId: "sc-1whrxo8-0"
})(["flex:1 0 auto;text-align:right;margin-left:", ";"], BASE_SPACING_X);
var UICardHeader = forwardRef(function (props, ref) {
  var className = props.className,
      expanded = props.expanded,
      onExpandedChange = props.onExpandedChange,
      title = props.title,
      titleSize = props.titleSize,
      toolbar = props.toolbar,
      rest = _objectWithoutProperties(props, ["className", "expanded", "onExpandedChange", "title", "titleSize", "toolbar"]);

  var isExpander = typeof onExpandedChange === 'function';
  var shorthandSize = toShorthandSize(titleSize);
  var renderedTitle = isExpander ? React.createElement(UIAccordionItem, {
    className: "private-card__title",
    flush: true,
    onOpenChange: onExpandedChange,
    open: expanded,
    title: title,
    size: shorthandSize
  }) : React.createElement(AbstractTextElement, {
    className: "private-card__title",
    tagName: headingForSize[shorthandSize]
  }, title);
  return React.createElement(UICardSection, Object.assign({}, rest, {
    ref: ref,
    className: classNames('private-card__header', className),
    isHeader: true
  }), React.createElement(UIFlex, {
    align: "start",
    justify: "between"
  }, renderedTitle, toolbar && expanded ? React.createElement(Toolbar, {
    className: "private-card__toolbar private-card__title"
  }, toolbar) : null));
});
UICardHeader.propTypes = Object.assign({}, omit(UICardSection.propTypes, ['children']), {
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func,
  title: PropTypes.node,
  titleSize: allSizes,
  toolbar: PropTypes.node
});
UICardHeader.defaultProps = {
  expanded: true,
  titleSize: 'md'
};
UICardHeader.displayName = 'UICardHeader';
export default UICardHeader;